"use strict";var e=require("./get/index.js");module.exports=r=>e(r);
//# sourceMappingURL=index.js.map
